// src/pages/income/business/IncomeBusinessDraftList.jsx
// ✅ 경영팀 "수입목록" 페이지 — 얇은 래퍼(IncomeBusinessDraftNew.jsx와 동일 원칙).
import React from "react";
import IncomeDraftList from "../_shared/IncomeDraftList";
import incomeBusinessDraftConfig from "./incomeBusinessDraftConfig";

export default function IncomeBusinessDraftList() {
  return <IncomeDraftList config={incomeBusinessDraftConfig} />;
}
